import { createContext } from 'react'
import { OptimizelyContextType, defaultOptimizelyContext } from 'models/Optimizely'

export const OptimizelyContext = createContext<OptimizelyContextType>(defaultOptimizelyContext)
